const firebaseConfig = {
    apiKey: "AIzaSyCueKfU4a3w9TzBIWZLx0kBth58HNDRVkY",
    authDomain: "creative-agency1-bd.firebaseapp.com",
    databaseURL: "https://creative-agency1-bd.firebaseio.com",
    projectId: "creative-agency1-bd",
    storageBucket: "creative-agency1-bd.appspot.com",
    messagingSenderId: "563492471700",
    appId: "1:563492471700:web:1e0c66530a48f822a98581"
  };

  export default firebaseConfig;